import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DynamicStyleLoaderService } from '../../utilities/dynamic-style-loader';

@Component({
    selector: 'my-account-emergency-contact-number',
    templateUrl: './emergency-contact-number.component.html',
    styleUrls: [],
    standalone: false
})
export class EmergencyContactNumberComponent implements OnInit {

  dialogData:any;
  constructor(@Inject(MAT_DIALOG_DATA) public data: any,private dynamicStyleLoader: DynamicStyleLoaderService) {
   this.dialogData = data.parentInstance;
  }  
  
  ngOnInit(){
    this.dynamicStyleLoader.focusCloseButton('mob-focus-phone','desktop-focus-phone'); 
  }

 
}


